import { useEffect } from 'react';
import { usePhase } from './use-phase';
import { usePhaseStep } from './use-phase-step';

import { getPhaseStepLimitKeyByOrder } from '../../shared/utils/phase';
import { pushCurrentDietCalculationStateToHistory } from '../../shared/utils/browserHistory';

// Custom hook, který slučuje logiku použití a fází a jednotlivých kroků fází v konfigurátoru + side effekty při změně fáze / kroku (modifikace URL adresy)
export const usePhaseAndPhaseStep = (cartItemId, dietId, sortedPhases) => {
    // TODO init app state from query string => ! validate send data if user not skipped steps !
    // const { initPhaseId, initPhaseStep } = useInitStateFromQueryString();
    const initPhaseId = undefined;
    const initPhaseStep = undefined;

    const { activePhase, setNextPhase, setPrevPhase, setSpecificPhase } = usePhase(sortedPhases, initPhaseId);

    const { activePhaseStep, setNextPhaseStep, resetPhaseStep, setSpecificPhaseStep, setPrevPhaseStep } = usePhaseStep(
        activePhase,
        initPhaseStep
    );

    const onPhaseClick = (phaseId) => {
        setSpecificPhase(phaseId);
        resetPhaseStep();
    };

    useEffect(() => {
        if (!activePhase) {
            return;
        }

        pushCurrentDietCalculationStateToHistory(cartItemId, dietId, activePhase.id, activePhaseStep);
    }, [cartItemId, dietId, activePhase, activePhaseStep]);

    const phaseIds = sortedPhases.map((phase) => phase.id);
    const phaseStepLimit = activePhase ? activePhase[getPhaseStepLimitKeyByOrder(activePhaseStep)] : 0;

    return {
        activePhase,
        activePhaseStep,
        setNextPhase,
        setPrevPhase,
        phaseIds,
        phaseStepLimit,
        setPrevPhaseStep,
        setSpecificPhaseStep,
        setNextPhaseStep,
        onPhaseClick,
        resetPhaseStep,
    };
};
